import React from "react";
import { Message } from "../../../typings/interfaces";
import { getFullCroatianDate } from "../../../utils/getFullCroatianDate";
import { formatDate } from "../../../services";

type Props = {
  message: Message;
  previousMessage?: Message;
}

export const FullDate = ({ message, previousMessage }: Props) => {
  const isPreviousMessageOnDifferentDay = previousMessage && (formatDate(message.sentAt) !== formatDate(previousMessage.sentAt))
  const shouldShowFullDate = !previousMessage || isPreviousMessageOnDifferentDay

  if (!shouldShowFullDate) return null;

  return (
    <div style={{ textAlign: "center", fontSize: 11, color: "#828282", marginBottom: 12 }}>
          {getFullCroatianDate(message.sentAt)}
    </div>
  )

}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/FullDate.tsx